import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import NewFormHeader from '../../../components/NewFormHeader';
import { Strings } from '../../../utils/strings';
import { Form, FormikProvider, useFormik } from 'formik';
import Dropdown from '../../../components/Dropdown';
import DateTimeContainer from '../../../components/DateTimeContainer';
import DateSelector from '../../../components/DateSelector';
import TimeSelector from '../../../components/TimeSelector';
import Button from '../../../components/Button';
import {
  AddArrivalDepartureSchema,
  AddArrivalDepartureForAdminSchema,
  AddAdminsDashboardArrivalDepartureSchema,
} from '../../../utils/validationSchemas';
import { connect } from 'react-redux';
import { fetchClientAllProperty } from '../../../redux/actions/clientActions/getClientAllProperty';
import { getErrorMessage, isClient } from '../../../utils/appUtils';
import { useAlert } from 'react-alert';
import { CircularProgress } from '@mui/material';
import { createJuncture } from '../../../redux/actions/clientActions/addJuncture';
import { updateJuncture } from '../../../redux/actions/clientActions/updateJuncture';
import moment from 'moment';
import classNames from 'classnames';
import { fetchUserListByType } from '../../../redux/actions/adminActions/getUserListByType';
import { fetchClientById } from '../../../redux/actions/clientActions/getClientById';
import { getFixedTimestamp } from '../../../utils/timeZone';

const NewArrivalDeparture = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const alert = useAlert();
  const [propertyData, setPropertyData] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [junctureId, setJunctureId] = useState('');
  const [minArrivalDate, setMinArrivalDate] = useState();

  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  const selectArrivalValue = async (value, arrivalTime) => {
    const currentTime = await new Date();
    const after15 = new Date(arrivalTime);
    after15.setMinutes(15);
    const after1Day = new Date(value);
    after1Day.setDate(new Date(value).getDate() + 1);
    await setFieldValue('arrivalDate', value);
    if (value) {
      await setFieldValue('departureDate', after1Day);
      // await setFieldValue('arrivalTime', moment(currentTime, 'HH:mm'));
      // await setFieldValue('departureTime', moment(after15, 'HH:mm'));
    }
  };

  useEffect(() => {
    if (!isClient() && props.isAdminsDashboardOnly) {
      props.fetchUserListByType('client', (err) => onError(err));
    }
    if (isClient()) {
      props.fetchClientAllProperty((err) => onError(err));
    }
  }, []);

  useEffect(() => {
    const data = props.UserListByTypeData ? props.UserListByTypeData : {};
    const newData =
      data?.data?.map((item) => {
        const tempData = {
          title: item.name,
          value: item._id,
        };
        // if (!props?.allTechnician && data?.type === 'array') tempData.image = item?.profilePicture;
        return tempData;
      }) || [];
    // if (!props?.allTechnician && data?.type === 'array') setTeamMemberList(newData);
    // if (data?.type === 'admin' && props.isEdit) {
    //   setAdminList(newData);
    //   setTempAdminList(newData);
    // }

    if (data?.type === 'client') setClientList(newData);
  }, [props.UserListByTypeData]);

  useEffect(() => {
    const data = props.clientAllPropertyData ? props.clientAllPropertyData : [];
    const newData = data.map((item) => ({
      title: item.name,
      value: item._id,
    }));
    setPropertyData(newData);
  }, [props.clientAllPropertyData]);

  const formik = useFormik({
    initialValues: {
      property:
        isClient() || props.isAdminsDashboardOnly ? '0' : props.propertyId,
      arrivalDate: '',
      arrivalTime: getFixedTimestamp(),
      departureDate: '',
      departureTime: getFixedTimestamp(),
      client: '0',
    },
    validationSchema: props.isAdminsDashboardOnly
      ? AddAdminsDashboardArrivalDepartureSchema
      : isClient()
      ? AddArrivalDepartureSchema
      : AddArrivalDepartureForAdminSchema,
    onSubmit: (values) => {
      const data = { property: values.property };
      if (values.arrivalDate && values.arrivalTime) {
        data.arrival = moment(
          moment(values.arrivalDate).format('YYYY-MM-DD') +
            ' ' +
            moment(values.arrivalTime).format('HH:mm')
        ).format();
      }
      if (values.departureDate && values.departureTime) {
        data.departure = moment(
          moment(values.departureDate).format('YYYY-MM-DD') +
            ' ' +
            moment(values.departureTime).format('HH:mm')
        ).format();
      }
      if (props.isEdit && junctureId) {
        let newData = { arrival: data.arrival, departure: data.departure };
        props.updateJuncture(
          junctureId,
          newData,
          (err) => onError(err),
          () => props.onNewClose()
        );
      } else {
        props.createJuncture(
          data,
          () => props.onNewClose(),
          (err) => onError(err)
        );
      }
    },
  });

  useEffect(() => {
    if (props?.isEdit && props?.arrivalDepartureData) {
      const { _id, arrival, departure, property, client } = props?.arrivalDepartureData;
      if(props.isAdminsDashboardOnly) {
        setFieldValue('client', client?._id);
      }
      setFieldValue('property', property?._id || property);
      if (arrival) {
        setFieldValue('arrivalDate', arrival);
        setFieldValue('arrivalTime', arrival);
      }
      if (departure) {
        setFieldValue('departureDate', departure);
        setFieldValue('departureTime', departure);
      }
      setJunctureId(_id);
      arrival
        ? new Date(arrival) > new Date()
          ? setMinArrivalDate(new Date())
          : setMinArrivalDate(new Date(arrival))
        : setMinArrivalDate();
    } else setJunctureId('');
  }, [props?.arrivalDepartureData]);

  const { errors, touched, values, handleChange, setFieldValue, handleSubmit } =
    formik;

  useEffect(() => {
    if (values.client !== '0')
      props.fetchClientById(values.client, (err) => onError(err));
  }, [values.client]);

  useEffect(() => {
    if (values.client !== '0') {
      const data = props.clientData ? props.clientData : {};
      const newData = data?.properties?.map((item) => ({
        title: item.name,
        value: item._id,
      }));
      setPropertyData(newData || []);
      if (newData && newData.length === 1 && values.client) {
        setFieldValue(
          'property',
          (values.property !== '0' && values.property) || newData[0].value,
        );
      } else {
        setFieldValue(
          'property',
          (values.property !== '0' && values.property) || '0',
        );
      }
    }
  }, [props.clientData]);

  return (
    <>
      <div className={classes.dialog_mask}>
        <div className={classes.dialog_container}>
          <NewFormHeader
            title={
              props?.isEdit
                ? Strings.EDIT_ARRIVALS_DEPARTURE
                : Strings.NEW_ARRIVALS_DEPARTURE
            }
            onNewClose={props.onNewClose}
          />
          {props.clientAllPropertyLoading || props.UserListByTypeLoading ? (
            <div className={classes.flexView}>
              <CircularProgress
                style={{
                  color: theme.palette.background_button,
                }}
              />
            </div>
          ) : (
            <FormikProvider value={formik}>
              <Form noValidate autoComplete='off' onSubmit={handleSubmit}>
                <div className={classes.form_container}>
                  {!isClient() && props.isAdminsDashboardOnly && (
                    <Dropdown
                      name='client'
                      onChange={(e) => {
                        setFieldValue('client', e.target.value);
                        setFieldValue('property', '0');
                      }}
                      value={values.client}
                      label={Strings.CLIENT}
                      error={Boolean(touched.client && errors.client)}
                      helperText={touched.client && errors.client}
                      title={Strings.SELECT_AN_OPTION}
                      labelClassName={classes.form_label}
                      inputContainerClass={
                        props?.isEdit && classes.disableInput
                      }
                      optionArray={clientList}
                      disabled={props?.isEdit ? true : false}
                    />
                  )}
                  {(isClient() || props.isAdminsDashboardOnly) && (
                    <Dropdown
                      name='property'
                      onChange={handleChange('property')}
                      value={values.property}
                      label={Strings.PROPERTY}
                      error={Boolean(touched.property && errors.property)}
                      helperText={touched.property && errors.property}
                      title={Strings.SELECT_AN_OPTION}
                      labelClassName={classes.form_label}
                      inputContainerClass={
                        props?.isEdit && classes.disableInput
                      }
                      containerClassName={classes.form_input_container}
                      optionArray={propertyData}
                      disabled={
                        (props.isAdminsDashboardOnly &&
                          values.client === '0') ||
                        props.clientLoading || props?.isEdit 
                      }
                    />
                  )}
                  {/* <div style={{ paddingTop: 40 }}>
                    <label className={classes.note_text}>
                      {props?.isEdit
                        ? Strings.EDIT_NOTE_TEXT
                        : Strings.ADD_NOTE_TEXT}
                    </label>
                  </div> */}
                  <DateTimeContainer
                    label={Strings.ARRIVAL_DATE_TIME}
                    containerClassName={classes.form_input_container}
                  >
                    <DateSelector
                      name='arrivalDate'
                      onChange={(value) =>
                        selectArrivalValue(value, values.arrivalTime)
                      }
                      value={values.arrivalDate}
                      error={Boolean(touched.arrivalDate && errors.arrivalDate)}
                      helperText={touched.arrivalDate && errors.arrivalDate}
                      format='MMM dd, yyyy'
                      placeholder={Strings.SAMPLE_DATE}
                      containerClassName={classes.date_selector_container}
                      // minDate={minArrivalDate}
                    />
                    <TimeSelector
                      name='arrivalTime'
                      onChange={(value) => {
                        setFieldValue('arrivalTime', value ? moment(value, 'HH:mm') : '');
                      }}
                      value={values.arrivalTime}
                      error={Boolean(touched.arrivalTime && errors.arrivalTime)}
                      helperText={touched.arrivalTime && errors.arrivalTime}
                      placeholder={Strings.SAMPLE_TIME}
                    />
                  </DateTimeContainer>
                  <DateTimeContainer
                    label={Strings.DEPARTURE_DATE_TIME}
                    containerClassName={classes.form_input_container}
                  >
                    <DateSelector
                      name='departureDate'
                      onChange={(value) =>
                        setFieldValue('departureDate', value)
                      }
                      value={values.departureDate}
                      error={Boolean(
                        touched.departureDate && errors.departureDate
                      )}
                      helperText={touched.departureDate && errors.departureDate}
                      format='MMM dd, yyyy'
                      placeholder={Strings.SAMPLE_DATE}
                      containerClassName={classes.date_selector_container}
                      minDate={
                        values.arrivalDate &&
                        new Date(values?.arrivalDate).setDate(
                          new Date(values?.arrivalDate).getDate()
                        )
                      }
                    />
                    <TimeSelector
                      name='departureTime'
                      onChange={(value) =>
                        setFieldValue('departureTime', value ? moment(value, 'HH:mm') : '')
                      }
                      value={values.departureTime}
                      error={Boolean(
                        touched.departureTime && errors.departureTime
                      )}
                      helperText={touched.departureTime && errors.departureTime}
                      placeholder={Strings.SAMPLE_TIME}
                    />
                  </DateTimeContainer>
                  <Button
                    type='submit'
                    text={props?.isEdit ? Strings.SAVE : Strings.ADD}
                    loading={
                      props?.isEdit
                        ? props.updateJunctureLoading
                        : props.addJunctureLoading
                    }
                    disabled={
                      props?.isEdit
                        ? props.updateJunctureLoading
                        : props.addJunctureLoading
                    }
                    containerClassName={classes.add_button_container}
                    className={classes.add_button}
                    loaderColor={theme.palette.background_button_text}
                  />
                </div>
              </Form>
            </FormikProvider>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  clientAllPropertyData: state.clientAllPropertyData.data,
  clientAllPropertyLoading: state.clientAllPropertyData.loading,

  addJunctureLoading: state.addJunctureData.loading,
  addJunctureData: state.addJunctureData.data,

  updateJunctureLoading: state.updateJunctureData.loading,

  UserListByTypeData: state.UserListByTypeData.data,
  UserListByTypeLoading: state.UserListByTypeData.loading,

  clientData: state.clientData.data,
  clientLoading: state.clientData.loading,
});

export default connect(mapStateToProps, {
  fetchClientAllProperty,
  createJuncture,
  updateJuncture,
  fetchUserListByType,
  fetchClientById,
})(NewArrivalDeparture);
